import Syllabic from "./SyllabicValue.js";
import Kananize from "./Kananize.js";

export default function(str, style) {
  switch (style) {
    case "kananize":
      return Kananize(str, true);
    default:
    case "traditional":
      return Syllabic(str, true);
    case "modern":
      return Syllabic(str, false);
  }
}
